import React, { useEffect, useState } from "react";
import { setCurrentWizardData } from "../../../../redux/actions/wizardActions";
import { createCredObject } from "../../../../common/factory/credential.factory";
import { useDispatch, useSelector } from "react-redux";
import { CredentialsType } from "../../../../common/interfaces/credentials/Credentials";
import { saveCred } from "../../../../redux/actions/credActions";
import { clone } from "../../../../common/utils/helper";

/**
 * The useEffect will start the creation.
 * It creates the Asset Import Token for working with Assets
 * It sets the currentData.importCredentialsReferences.assetImportTokenRefId You should listen to this property to know when to create the flow.
 *
 */
const SaveAssetToken = ({ assetTokenName}) => {
  const [count, setCount] = useState(0);

  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);
  const workspace = useSelector((state) => state.jiraAssets.workspace);
  const token = useSelector((state) => state.jiraAssets.token);

  const importSource = useSelector((state) => state.jiraAssets.importSource);
  const selectedAssetSchema = useSelector(
    (state) => state.jiraAssets.selectedAssetSchema
  );
  const importSourceName = useSelector(
    (state) => state.jiraAssets.importSourceName
  );

  //init the create asset token
  useEffect(() => {
    if (
      count === 0 &&
      !currentData?.importCredentialsReferences?.assetImportTokenRefId &&
      workspace &&
      importSource &&
      selectedAssetSchema &&
      importSourceName &&
      token
    ) {
      const tokenObj = createCredObject(assetTokenName, CredentialsType.TOKEN);
      tokenObj.data = { token: token };
      const tokenPromise = dispatch(saveCred(tokenObj));
      Promise.all([tokenPromise])
        .then((results) => {
          if (!currentData.importCredentialsReferences) {
            currentData.importCredentialsReferences = {
              assetImportTokenRefId: results[0]?.id,
            };
          } else {
            currentData.importCredentialsReferences.assetImportTokenRefId = results[0]?.id
          }

          dispatch(setCurrentWizardData(clone(currentData)));
        })
        .catch((error) => {
          console.error("Error saving credentials:", error);
        });
      //block recursive creation
      setCount(1)
    }
  }, [currentData, token]);
  return (<></>)

};

export default SaveAssetToken;